module.exports = __webpack_public_path__ + "img/grey.0220845.svg";